import MainLayout from "Layouts/Main";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { getAllSubModuleQuestions_USER, getUserFeedbackModule } from "../../../../Redux/Slices/User/userSlice";
import "./styles.scss";
import SubModule from "Components/SubModule";
import AssessmentAnswer from "Components/AssessmentAnswer";
import {
  addAssessmentAnswerScore,
  addSparePartsLog,
  addSpartParts,
  getSpareParts,
  getAdditionalInsightsDetail,
  getPreviousAnswerDetails,
  getUserAnswer,
  updateAssessmentAnswerScore,
  getPreviewDetail,
  updateSparePartsLog,
  setCompanyName,
  getProductName
} from "../../../../Redux/Slices/Accessor/accessorSlice";
import { useSelector } from 'react-redux';
import {
  setSpareParts,
  updateSparePart,
  markSparePartAsDeleted,
  addNewSparePart,
  setCurrentSparePartIndex
} from '../../../../Redux/Slices/Accessor/sparePartsSlice';
import {
  addSparePartEntry,
  updateSparePartField,
  deleteSparePartEntry,
  clearAllSparePartEntries
} from "../../../../Redux/Slices/Accessor/sparePartUploaderSlice";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import SparePartUploader from "Components/SparePartUploader";
import Button from "Components/Button";
import SparePartLogo from "Components/SparePartsLogo";
import scrollToTop from "Services/Utils/scrolltoTop";
import Loader from "Components/Loader";

const renderNavigationButtons = ({
  isTransitioning,
  currentCategoryIndex,
  currentSubCategoryIndex,
  issparepartNameImageCategory,
  isSparePartsCategory,
  categories,
  previousButtonStyle,
  previousTitle,
  buttonTitleStyle,
  buttonStyle,
  handlePrevious,
  handleSubmitNameImage,
  handleSubmitSpare,
  handleSubmit,
  handleNext,
}) => {
  if (isTransitioning) return null;

  const isReviewed =
    categories[currentCategoryIndex]?.sub_categories[currentSubCategoryIndex]
      ?.is_reviewed;

  return (
    <div className="d-flex justify-content-end my-3 me-3">
      {/* Previous Button */}
      <div className="me-3">
        {!(currentCategoryIndex === 0 && currentSubCategoryIndex === 0) && (
          <Button
            title="Previous"
            buttonStyle={previousButtonStyle}
            titleStyle={previousTitle}
            onClick={handlePrevious}
          />
        )}
      </div>

      {/* Conditional Main Button */}
      {issparepartNameImageCategory ? (
        <Button
          title="Submit & Preview"
          titleStyle={buttonTitleStyle}
          buttonStyle={buttonStyle}
          onClick={handleSubmitNameImage}
        />
      ) : isReviewed ? (
        <Button
          title="Update & Next"
          titleStyle={buttonTitleStyle}
          buttonStyle={buttonStyle}
          forForm={true}
          onClick={handleNext}
        />
      ) : (
        <Button
          title="Submit & Next"
          titleStyle={buttonTitleStyle}
          buttonStyle={buttonStyle}
          forForm={true}
          onClick={isSparePartsCategory ? handleSubmitSpare : handleSubmit}
        />
      )}
    </div>
  );
};


const ViewReviewAssessment = () => {
  const { spareParts, currentSparePartIndexx } = useSelector(state => state.spareParts);

  const [activeCategoryId, setActiveCategoryId] = useState("");
  const [currentCategoryIndex, setCurrentCategoryIndex] = useState(0);
  const [currentSubCategoryIndex, setCurrentSubCategoryIndex] = useState(0);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [partType, setPartType] = useState("");
  const [partNumber, setPartNumber] = useState("");
  // const [currentBrand, setCurrentBrand] = useState("");
  const [applicationArea, setApplicationArea] = useState("");
  // const [operatingCondition, setOperationgCondition] = useState("");
  const [issuesFaced, setIssuesFaced] = useState("");
  const [spareFiles, setSpareFiles] = useState([]);
  // const [sparePartsData, setSparePartsData] = useState([]);
  const [uploadError, setUploadError] = useState("");
  // const [hasExistingSpareData, setHasExistingSpareData] = useState(false);
  const [previousDataTemp, setPreviousDataTemp] = useState([]);
  const [currentSparePartIndex, setCurrentSparePartIndex] = useState(0);
  const [isloading, setIsloading] = useState(false);
  const { AssesmentId } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();


  const [disabled, setDisabled] = useState(false);
  const [productOptions, setProductOptions] = useState([]);
  const [moduleOptions, setModuleOptions] = useState([])
  const [previewParts, setPreviewParts] = useState([]);
  const [selectedProductIndex, setSelectedProductIndex] = useState(null);


  const formMethods = useForm({
    defaultValues: {
      categories: [],
    },
  });
  const { watch, setValue } = formMethods;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const assessment_id = location?.state?.assessment_id;
  const categoryId = location?.state?.category_id;
  const subCategoryId = location?.state?.sub_category_id;
  const questionId = location?.state?.question_id;
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const assessor_id = userDetails?.user_id;
  const categories = watch("categories");
  const [activeSparePartId, setActiveSparePartId] = useState(null);
  const [productName, setproductName] = useState("");
  const [ImageFile, setImageFile] = useState(null);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const sparePartUploaderData = useSelector(state => state.sparePartUploader.uploads);

  const company_name = useSelector((state) => state.accessor.company_name) || location?.state?.company_name;

  const roleMap = {
    1: "Admin",
    2: "Assessor",
    3: "User",
    4: "Approver"
  };
  const roleName = roleMap[userDetails?.role];
  const sparepartNameImageCategory = {
    category_id: (categories?.length || 0) + 2,
    category_name: " PRODUCT MAPPING",
    // category_name: " KG SPARE PARTS",  
    sub_categories: [],
  };

  const buttonTitleStyle = {
    fontSize: "16px",
    fontWeight: "600",
  };

  const buttonStyle = {
    height: "44px",
    oultine: "none",
    border: "1px solid  #1f2155",
  };

  const previousButtonStyle = {
    height: "44px",
    border: "1.5px solid #00000033",
    background: "#FDFDFD",
  };

  const previousTitle = {
    fontSize: "16px",
    fontWeight: "400",
    color: "#000000",
  };

  const handleDeleteSparePart = (index) => {
    const updatedParts = [...spareParts];
    updatedParts[index] = {
      ...updatedParts[index],
      is_deleted: true
    };
    dispatch(setSpareParts(updatedParts));

    // If deleting active part, clear the form
    if (index === activeSparePartId) {
      setPartType("");
      setPartNumber("");
      setApplicationArea("");
      setIssuesFaced("");
      setSpareFiles([]);
      setActiveSparePartId(null);
    }
  };

  const handleSparePartChange = (index, field, value) => {
    const updatedParts = [...spareParts];
    if (!updatedParts[index]) {
      updatedParts[index] = {};
    }
    updatedParts[index] = {
      ...updatedParts[index],
      [field]: value,
      is_deleted: false
    };
    dispatch(setSpareParts(updatedParts));
  };

  // Add new spare part

  // Modified add another spare part handler
  const addAnotherSparePart = () => {
    // Save current part's data if it exists
    if (partNumber || partType || applicationArea || issuesFaced || spareFiles.length > 0) {
      const newPart = {
        priority: partNumber,
        module_name: partType,
        product_name: applicationArea,
        recommendations: issuesFaced,
        photos: spareFiles,
        is_deleted: false
      };

      if (spareParts.length === 0) {
        // For the first part, set it and then add a new empty part
        dispatch(setSpareParts([newPart]));
        dispatch(addNewSparePart());
      } else {
        // For subsequent parts, just add the new part
        dispatch(addNewSparePart(newPart));
      }
    } else {
      // If no current data, just add an empty part
      dispatch(addNewSparePart());
    }

    // Clear form fields
    setPartType("");
    setPartNumber("");
    setApplicationArea("");
    setIssuesFaced("");
    setSpareFiles([]);

    // Set the new part as active
    setActiveSparePartId(spareParts.length);
  };

  // Update form fields when current spare part changes
  useEffect(() => {
    if (spareParts[currentSparePartIndex]) {
      const currentPart = spareParts[currentSparePartIndex];
      setPartType(currentPart.module_name || '');
      setPartNumber(currentPart.priority || '');
      setApplicationArea(currentPart.product_name || '');
      setIssuesFaced(currentPart.recommendations || '');
      setSpareFiles(currentPart.photos || []);
    }
  }, [currentSparePartIndex]);


  //   const onModuleSelect = (index, newModuleValue, moduleId) => {
  //   dispatch(
  //     getProductName({
  //       moduleId,
  //       callBack: (productList) => {
  //         if (!Array.isArray(productList)) return;

  //         const formattedProducts = productList.map(item => ({
  //           label: item.product_name,
  //           value: item.product_name,
  //           images: item.images || [],
  //         }));

  //         setProductOptions(prev => {
  //           const copy = [...prev];
  //           copy[index] = formattedProducts;
  //           return copy;
  //         });

  //         const previewPart = previewParts[index];
  //         const currentPart = spareParts[index];

  //         // Keep existing product_name or fallback to first API product
  //         const product_name = currentPart?.product_name || formattedProducts[0]?.value || "";

  //         // Keep existing photos if they exist, otherwise take images from API
  //         const photos = (currentPart?.photos && currentPart.photos.length > 0)
  //           ? currentPart.photos
  //           : formattedProducts.flatMap(product =>
  //               (product.images || []).map(url => ({
  //                 url,
  //                 name: url.split("/").pop()
  //               }))
  //             );

  //         const updatedPart = {
  //           module_name: newModuleValue,
  //           product_name,
  //           photos,
  //           is_deleted: false
  //         };

  //         const updatedParts = [...spareParts];
  //         updatedParts[index] = {
  //           ...updatedParts[index],
  //           ...updatedPart
  //         };

  //         dispatch(setSpareParts(updatedParts));
  //       }
  //     })
  //   );
  // };

  const onModuleSelect = (index, newModuleValue, moduleId) => {
    const previewPart = previewParts[index];
    const currentPart = spareParts[index];

    dispatch(
      getProductName({
        moduleId,
        callBack: (productList) => {
          if (!Array.isArray(productList)) return;

          const formattedProducts = productList.map(item => ({
            label: item.product_name,
            value: item.product_name,
            images: item.images || [],
          }));

          setProductOptions(prev => {
            const copy = [...prev];
            copy[index] = formattedProducts;
            return copy;
          });

          const isPreviewModule = previewPart?.module_name === newModuleValue;

          const updatedParts = [...spareParts];
          updatedParts[index] = {
            ...currentPart,
            module_name: newModuleValue,
            product_name: isPreviewModule
              ? previewPart.product_name || ""
              : formattedProducts[0]?.value || "",
            photos: isPreviewModule
              ? previewPart.photos || []
              : formattedProducts[0]?.images?.[0]
                ? [{ url: formattedProducts[0].images[0], name: formattedProducts[0].images[0].split("/").pop() }]
                : [],
            is_deleted: false,
          };

          dispatch(setSpareParts(updatedParts));
        }
      })
    );
  };

  const onProductSelect = (index, selectedValue) => {
    const currentPart = spareParts[index];
    const products = productOptions[index] || [];

    const productIndex = products.findIndex(p => p.value === selectedValue);
    if (productIndex === -1) return;

    const selectedProduct = products[productIndex];

    let photosToUse = currentPart.photos;

    // If user selects a NEW product → replace photos with default
    if (currentPart.product_name !== selectedProduct.value) {
      photosToUse = selectedProduct.images?.[0]
        ? [{
          url: selectedProduct.images[0],
          name: selectedProduct.images[0].split("/").pop()
        }]
        : [];
    }

    const updatedParts = [...spareParts];
    updatedParts[index] = {
      ...currentPart,
      product_name: selectedProduct.value,
      photos: photosToUse,
      is_deleted: false,
    };

    dispatch(setSpareParts(updatedParts));
  };






  //preview sent to sparepartlogo

  const handlePreviewReady = (index, moduleOptions, spareParts) => {
    const part = spareParts[index];
    if (part?.module_name) {
      const selectedModule = moduleOptions.find(m => m.label === part.module_name);
      if (selectedModule?.id) {
        onModuleSelect(index, part.module_name, selectedModule.id);
      }
    }
  };



  // Handle preview data
  const getPreviewDetailsData = (data) => {
    if (data?.sparePartLogData) {
      const spareData = Array.isArray(data.sparePartLogData)
        ? data.sparePartLogData
        : [data.sparePartLogData];

      const formattedSpareData = spareData.map(part => ({
        ...part,
        photos: Array.isArray(part.photos) ? part.photos : [],
        is_deleted: false
      }));

      dispatch(setSpareParts(formattedSpareData));
      setPreviewParts(formattedSpareData);
    }
    getAllCategories(data);
  };

  // Handle spare parts submission
  const handleSubmitSpare = () => {
    let partsToSubmit = [...spareParts];

    // If there's unsaved data in the form and no parts exist yet
    if (spareParts.length === 0 && (partNumber || partType || applicationArea || issuesFaced || spareFiles.length > 0)) {
      const currentPart = {
        priority: partNumber,
        module_name: partType,
        product_name: applicationArea,
        recommendations: issuesFaced,
        photos: spareFiles,
        is_deleted: false
      };
      partsToSubmit = [currentPart];
    }
    // If there's unsaved data and we're editing an existing part
    else if (partNumber || partType || applicationArea || issuesFaced || spareFiles.length > 0) {
      const currentPart = {
        ...partsToSubmit[currentSparePartIndex],
        priority: partNumber,
        module_name: partType,
        product_name: applicationArea,
        recommendations: issuesFaced,
        photos: spareFiles,
        is_deleted: false
      };
      partsToSubmit[currentSparePartIndex] = currentPart;
    }

    const payloadArray = {
      finalSubmit: false,
      assessment_id: assessment_id ? assessment_id : AssesmentId,
      data: partsToSubmit.map(sparePart => ({
        ...(sparePart.spare_parts_log_id && { spare_parts_log_id: sparePart.spare_parts_log_id }),
        assessment_id: assessment_id ? assessment_id : AssesmentId,
        assessor_id: assessor_id,
        company_name: company_name,
        module_name: sparePart.module_name,
        priority: sparePart.priority,
        product_name: sparePart.product_name,
        recommendations: sparePart.recommendations,
        photos: Array.isArray(sparePart.photos)
          ? sparePart.photos.map(file =>
            typeof file === "string" ? file : file?.url
          ).filter(Boolean)
          : [],
        is_deleted: sparePart.is_deleted,
        is_added: Boolean(!sparePart.spare_parts_log_id)
      }))
    };

    // Navigate to name image uploader instead of preview
    setCurrentCategoryIndex(categories.length + 1);
    setActiveCategoryId(sparepartNameImageCategory.category_id);

    dispatch(setSpareParts(partsToSubmit));

    if (spareParts.some(part => part.spare_parts_log_id)) {
      dispatch(updateSparePartsLog({
        data: payloadArray,
        callBack: () => {
          // After successful spare parts submission, move to name image uploader
          setCurrentCategoryIndex(categories.length + 1);
          setActiveCategoryId(sparepartNameImageCategory.category_id);
        },
      }));
    } else {
      const payloadWithoutFlags = {
        ...payloadArray,
        data: payloadArray.data.map(({ is_added, is_deleted, ...rest }) => rest)
      };

      dispatch(addSparePartsLog({
        data: payloadWithoutFlags,
        callBack: () => {
          // After successful spare parts submission, move to name image uploader
          setCurrentCategoryIndex(categories.length + 1);
          setActiveCategoryId(sparepartNameImageCategory.category_id);
        },
      }));
    }
    scrollToTop();
  };

  // Handle name image submission
  const handleSubmitNameImage = () => {
    const cleanedData = sparePartUploaderData.map(({ uploadError, ...rest }) => ({
      ...rest,
      backlog_id: Number(AssesmentId),
    }));

    console.log("SparePartUploader Data:", cleanedData);

    dispatch(
      addSpartParts({
        data: cleanedData,
        callBack: () => {
          console.log("Spare parts uploaded successfully");
          navigate(`/assessment-review/view-assessment/preview/${AssesmentId}`, {
            state: {
              assessment_id: AssesmentId,
            },
          });
        },
      })
    );
  };



  const renderSpareParts = () => (
    <div className="spare-parts-container">
      {spareParts.map((sparePart, index) => (
        !sparePart.is_deleted && (
          <div key={`spare-part-${index}`} className="spare-part-item">
            <SparePartLogo
              isOne={spareParts.filter(part => !part.is_deleted).length === 1}
              AddAnotherSparePart={addAnotherSparePart}
              handleDelete={() => handleDeleteSparePart(index)}
              isActive={activeSparePartId === index}
              onActivate={() => setActiveSparePartId(index)}
              files={sparePart.photos || []}
              uploadError={uploadError}
              setUploadError={setUploadError}
              partNumber={sparePart.priority || ''}
              partType={sparePart.module_name || ''}
              applicationArea={sparePart.product_name || ''}
              issuesFaced={sparePart.recommendations || ''}
              setFiles={(files) => handleSparePartChange(index, "photos", files)}
              setPartNumber={(value) => handleSparePartChange(index, "priority", value)}
              setPartType={(value) => handleSparePartChange(index, "module_name", value)}
              setApplicationArea={(value) => handleSparePartChange(index, "product_name", value)}
              setIssuesFaced={(value) => handleSparePartChange(index, "recommendations", value)}
              index={index}
              onModuleSelect={onModuleSelect}
              productOptions={productOptions}
              setModuleOptions={setModuleOptions}
              previewReady={(moduleOptions) => handlePreviewReady(index, moduleOptions, spareParts, onModuleSelect)}
              setSelectedProductIndex={setSelectedProductIndex}
              onProductSelect={onProductSelect}
            />
          </div>
        )
      ))}

      {spareParts.length === 0 && (
        <SparePartLogo
          isOne={true}
          AddAnotherSparePart={addAnotherSparePart}
          files={spareFiles}
          uploadError={uploadError}
          setUploadError={setUploadError}
          partNumber={partNumber}
          partType={partType}
          applicationArea={applicationArea}
          issuesFaced={issuesFaced}
          setFiles={setSpareFiles}
          setPartNumber={setPartNumber}
          setPartType={setPartType}
          setApplicationArea={setApplicationArea}
          setIssuesFaced={setIssuesFaced}
          index={0}
          onModuleSelect={onModuleSelect}
          productOptions={productOptions}
          setModuleOptions={setModuleOptions}
          setSelectedProductIndex={setSelectedProductIndex}
          onProductSelect={onProductSelect}
        />
      )}

      <div>
        {renderNavigationButtons({
          isTransitioning,
          currentCategoryIndex,
          currentSubCategoryIndex,
          issparepartNameImageCategory,
          isSparePartsCategory,
          categories,
          previousButtonStyle,
          previousTitle,
          buttonTitleStyle,
          buttonStyle,
          handlePrevious,
          handleSubmitNameImage,
          handleSubmitSpare,
          handleSubmit,
          handleNext,
        })}
      </div>
    </div>
  );

  useEffect(() => {
    getPreviewDetails()
  }, []);

  const getPreviewDetails = () => {
    setIsloading(true);
    dispatch(
      getPreviewDetail({
        assessment_id: assessment_id ? assessment_id : AssesmentId,
        callBack: getPreviewDetailsData,
      })
    );
  };

  const getAllCategories = (data) => {
    // setPreviewData(data?.data);
    dispatch(
      getAllSubModuleQuestions_USER({
        callBack: (returnedData) => {
          getAllData(returnedData, data?.data);
          setIsloading(false);
        }
      })
    );
  };

  const getAllData = (data, previewData) => {
    // Process the existing data as before
    // console.log(previewData, "dataPP");
    data = data?.map((item) => {
      return {
        ...item,
        sub_categories: [
          ...item?.sub_categories?.map((element, index) => {
            return {
              ...element,

              questions: element?.questions?.map((y) => {
                const isAnyAnswerPresent = previewData?.some(pd =>
                  pd?.question_name?.question_id === y?.question_id &&
                  pd?.answers?.some(ans =>
                    (ans?.options?.title) ||
                    (ans?.text_answer) ||
                    (ans?.grease_name) ||
                    (ans?.grease_size) ||
                    (ans?.subOption)
                  )
                );
                const approverFeedbackItem = previewData?.find(pd =>
                  pd?.question_name?.question_id === y?.question_id &&
                  pd?.research_data?.[0]?.approver_feedback &&
                  pd?.research_data[0].approver_feedback.trim().length > 0
                );

                const approverFeedback = approverFeedbackItem?.research_data?.[0]?.approver_feedback || "";
                const approverFeedbackUpload = approverFeedbackItem?.research_data?.[0]?.approver_feedback_upload || "";


                return {
                  ...y,
                  isAnyAnswerPresent,
                  isApproverFeedback: !!approverFeedback, // still keeps the boolean
                  approverFeedback,
                  approverFeedbackUpload,
                  observation: "",
                  evidence: y.evidence?.length ? y.evidence : [{ files: [], description: "" }],
                  insights: "",
                  recommendation: y.recommendation?.length ? y.recommendation : [{ files: [], recText: "" }],
                  userAnswer: [],
                  finalScore: "",
                  options: y?.options?.map((z) => {
                    return {
                      ...z,
                      isChecked: false,
                    };
                  }),
                };
              }),
              isCompleted: previewData?.some(
                (item) =>
                  item?.sub_category_name?.subCategory_name === element.subCategory_name &&
                  item?.research_data?.length > 0
              ) || false,
              is_reviewed: false,
            };
          }),
          {
            subCategory_id: item?.sub_categories?.length + 1,
            subCategory_name: "Additional insights",
            additionalInsightsData: [],
            questions: [],
            isCompleted: true,
            is_reviewed: false,
          },
          {
            subCategory_id: item?.sub_categories?.length + 2,
            subCategory_name: "Feedback",
            questions: [],
            feedbackData: [],
            isFeedback: true,
            isCompleted: true,
            is_reviewed: true,
          },
        ],
      };
    });
    const newCategory = {
      category_id: data.length + 1,
      category_name: "KG PRODUCT OFFERINGS",
      sub_categories: [],
    };

    data.push(newCategory);

    // Update the state with the modified data
    setValue("categories", data);

    const updatedData = [...data];

    if (updatedData.length && categoryId && subCategoryId) {
      const catIndex = updatedData.findIndex(cat => cat.category_id === categoryId);
      const subCatIndex = updatedData[catIndex]?.sub_categories?.findIndex(sub => sub.subCategory_id === subCategoryId);

      if (catIndex !== -1 && subCatIndex !== -1) {
        setActiveCategoryId(categoryId);
        setCurrentCategoryIndex(catIndex);
        setCurrentSubCategoryIndex(subCatIndex);
      }
    } else if (data.length > 0 && !categoryId && !subCategoryId) {
      setActiveCategoryId(data[0].category_id);
    }
  };

  useEffect(() => {
    if (categories?.length > 0) {
      const currentCategory = categories[currentCategoryIndex]?.category_id;
      const currentSubCategory = categories[currentCategoryIndex]?.sub_categories[currentSubCategoryIndex]?.subCategory_id;
      const currentQuestion = categories[currentCategoryIndex]?.sub_categories[currentSubCategoryIndex]?.questions[currentQuestionIndex]?.question_id;

      setSearchParams({
        currentCategory,
        currentSubCategory,
      }, { replace: true })
    }
  }, [currentCategoryIndex, currentSubCategoryIndex, currentQuestionIndex]);

  const category_id = categories[currentCategoryIndex]?.category_id;
  const sub_category_id =
    categories[currentCategoryIndex]?.sub_categories[currentSubCategoryIndex]
      ?.subCategory_id;
  const question_id =
    categories[currentCategoryIndex]?.sub_categories[currentSubCategoryIndex]
      ?.questions[currentQuestionIndex]?.question_id;

  const isLastSubCategory =
    currentSubCategoryIndex ===
    categories[currentCategoryIndex]?.sub_categories?.length - 1;

  const isAdditionalInsights = currentSubCategoryIndex === categories[currentCategoryIndex]?.sub_categories?.length - 2;

  const isLastCategory = currentCategoryIndex === categories?.length - 1;
  const isSparePartsCategory = currentCategoryIndex === categories?.length - 1;
  const issparepartNameImageCategory = currentCategoryIndex === categories?.length + 1;

  useEffect(() => {
    if (issparepartNameImageCategory) {
      dispatch(getSpareParts({
        assessment_id: AssesmentId,
        callBack: (data) => {
          // Clear existing entries first
          dispatch(clearAllSparePartEntries());

          // Transform the API data to match the component's expected format
          if (data && data.length > 0) {
            data.forEach(item => {
              dispatch(addSparePartEntry());
              const index = data.indexOf(item);

              // Update each field for the spare part entry
              dispatch(updateSparePartField({
                index,
                field: "product_name",
                value: item.product_name || ""
              }));

              dispatch(updateSparePartField({
                index,
                field: "photos",
                value: item.photos || []
              }));

              dispatch(updateSparePartField({
                index,
                field: "backlog_id",
                value: item.backlog_id
              }));

              // Store the log_id for potential updates/deletes
              dispatch(updateSparePartField({
                index,
                field: "log_id",
                value: item.log_id
              }));
            });
          } else {
            // If no data, add one empty entry
            dispatch(addSparePartEntry());
          }
        }
      }));
    }
  }, [issparepartNameImageCategory, AssesmentId, dispatch]);

  useEffect(() => {
    if (categories.length > 0 && !isLastSubCategory && !isLastCategory && !issparepartNameImageCategory && !isAdditionalInsights) {
      getUserAnswerData(category_id, sub_category_id);
    }
  }, [categories.length, category_id, sub_category_id]);

  const getUserAnswerData = (category_id, sub_category_id) => {
    dispatch(
      getUserAnswer({
        assessment_id: AssesmentId,
        category_id: category_id,
        sub_category_id: sub_category_id,
        company_name: company_name,
        callBack: getUserAnswerDetails,
      })
    );
  };

  const getUserAnswerDetails = (data) => {
    const answers = data?.data?.answers || [];
    const updatedData = [...categories];

    const areAllAnswersEmpty = answers.every((ans) => {
      return (
        !ans.option_id &&
        !ans.text_answer &&
        !ans.grease_name &&
        !ans.grease_size &&
        !ans.sub_option_id
      );
    });
    if (answers?.length === 0 || areAllAnswersEmpty) {
      setDisabled(true)
      updatedData[currentCategoryIndex].sub_categories[
        currentSubCategoryIndex
      ].questions[currentQuestionIndex].userAnswer = [];
    }
    else {
      setDisabled(false);

      updatedData[currentCategoryIndex].sub_categories[
        currentSubCategoryIndex
      ].questions[currentQuestionIndex].userAnswer = data?.data?.answers;
    }

    setValue("categories", updatedData);
  };

  // Additional insights API
  useEffect(() => {
    if (isAdditionalInsights && !isLastCategory && !issparepartNameImageCategory) {
      getAdditionalInsights();
    } else if (isLastSubCategory && !isLastCategory && !issparepartNameImageCategory) {
      getIndividualFeedback();
    }
  }, [currentSubCategoryIndex, currentCategoryIndex, categories.length]);

  const getAdditionalInsights = () => {
    dispatch(
      getAdditionalInsightsDetail({
        assessment_id: assessment_id ? assessment_id : AssesmentId,
        category_id: category_id,
        company_name: company_name,
        callBack: getAdditionalInsightsData,
      })
    );
  };

  const getIndividualFeedback = () => {
    dispatch(
      getUserFeedbackModule({
        assessment_id: assessment_id ? assessment_id : AssesmentId,
        category_id: category_id,
        role: roleName.toLowerCase(),
        callBack: (data) => handleGetFeedback(data, category_id),
      })
    );
  }

  const handleGetFeedback = (data, categoryId, subCategoryId) => {
    const response = data?.feedback;
    const feedbackDataFromAPI = response?.map((item) => {
      return {
        comments: item?.comment,
        rating: item?.rating,
      };
    });
    const updatedData = [...categories];
    updatedData[currentCategoryIndex].sub_categories[
      currentSubCategoryIndex
    ].feedbackData = feedbackDataFromAPI;
    setValue("categories", updatedData);
  };


  const getAdditionalInsightsData = (data) => {
    const response = data?.data;
    const additionalInsightsData = response?.map((item) => {
      return {
        mediaFiles: item?.media_files,
        comments: item?.comments,
        userName: item?.user_name,
      };
    });

    const updatedData = [...categories];
    updatedData[currentCategoryIndex].sub_categories[
      currentSubCategoryIndex
    ].additionalInsightsData = additionalInsightsData;
    setValue("categories", updatedData);
  };

  useEffect(() => {
    if (categories.length && !isLastSubCategory && !isLastCategory && !issparepartNameImageCategory && !isAdditionalInsights) {
      getPreviousAnswer();
    }
  }, [
    categories.length,
    currentCategoryIndex,
    currentSubCategoryIndex,
    currentQuestionIndex,
  ]);

  // Previous Data API
  const getPreviousAnswer = () => {
    dispatch(
      getPreviousAnswerDetails({
        assessment_id: AssesmentId,
        category_id: category_id,
        sub_category_id: sub_category_id,
        question_id: question_id,
        callBack: getPreviousAnswerData,
      })
    );
  };

  const getPreviousAnswerData = (data) => {
    setPreviousDataTemp(data?.data);
    const { research_data, recommendation_data } = data?.data;
    const research = research_data[0];

    const updatedData = [...categories];
    const activeQuestionData =
      updatedData[currentCategoryIndex]?.sub_categories[currentSubCategoryIndex]
        ?.questions[currentQuestionIndex];
    const activeSubCategory =
      updatedData[currentCategoryIndex]?.sub_categories[
      currentSubCategoryIndex
      ];

    activeQuestionData.observation = research?.notes || "";
    activeQuestionData.insights = research?.insights || "";
    activeQuestionData.finalScore = research?.final_score || "";
    activeSubCategory.is_reviewed = research?.is_reviewed;

    if (research?.final_score) {
      updatedData[currentCategoryIndex].sub_categories[
        currentSubCategoryIndex
      ].isCompleted = true;
    }

    // Map evidence directly without grouping
    activeQuestionData.evidence = Array.isArray(research?.upload)
      ? research.upload.map((ev) => ({
        files: Array.isArray(ev?.image_url)
          ? ev.image_url
          : ev?.image_url ? [ev.image_url] : [],
        description: ev?.text || ""
      }))
      : [];

    // Map recommendations directly without grouping
    if (Array.isArray(recommendation_data) && recommendation_data.length > 0) {
      activeQuestionData.recommendation = recommendation_data.map((r) => ({
        recText: r?.message || "",
        files: Array.isArray(r?.image_url)
          ? r.image_url
          : r?.image_url ? [r.image_url] : [],
      }));
    } else {
      activeQuestionData.recommendation = [{ files: [], recText: "" }];
    }

    setValue("categories", updatedData)
  };

  const handleTab = (category_id, index) => {
    setActiveCategoryId(category_id);
    setCurrentCategoryIndex(index);
    setCurrentSubCategoryIndex(0);
    scrollToTop(".sub-module-wrap")
  };

  const filteredSubCategories = categories?.find(
    (cat) => cat?.category_id === activeCategoryId
  )?.sub_categories;

  const handlePrevious = () => {
    if (issparepartNameImageCategory) {
      // Move back to spare parts category
      setCurrentCategoryIndex(categories.length - 1);
      setActiveCategoryId(categories[categories.length - 1]?.category_id);
      return;
    }

    const isFirstSubCategory = currentSubCategoryIndex === 0;
    const isFirstCategory = currentCategoryIndex === 0;

    if (isFirstSubCategory && !isFirstCategory) {
      // Move to the previous category
      setCurrentCategoryIndex((prev) => prev - 1);
      setActiveCategoryId(categories[currentCategoryIndex - 1]?.category_id);

      // Get the last subcategory of the previous category
      const lastSubCategoryIndex =
        categories[currentCategoryIndex - 1]?.sub_categories.length - 1;
      setCurrentSubCategoryIndex(lastSubCategoryIndex); // Move to the last subcategory of the previous category
    } else if (!isFirstSubCategory) {
      // Move to the previous subcategory within the same category
      setCurrentSubCategoryIndex((prev) => prev - 1);
    }
    scrollToTop()
  };

  const handleSubmit = () => {
    const data =
      categories[currentCategoryIndex]?.sub_categories[currentSubCategoryIndex]
        ?.questions[currentQuestionIndex];

    const userData = Array.isArray(data?.userAnswer)
      ? data?.userAnswer.map((item) => ({
        user_id: item?.user_id,
        user_name: item?.user_name,
      }))
      : [];

    const uploads = Array.isArray(data?.evidence)
      ? data.evidence.map((ev) => ({
        image_url:
          Array.isArray(ev?.files) && ev.files.length > 0 ? ev.files : [],
        text: ev?.description || "",
      })).filter((evidence) => evidence?.image_url?.length > 0 || evidence?.text !== "")
      : [];


    const recommendations = Array.isArray(data?.recommendation)
      ? data.recommendation.map((rec) => ({
        image_url:
          Array.isArray(rec?.files) && rec.files.length > 0 ? rec.files : [],
        message: rec?.recText || "",
      }))
        .filter(
          (rec) => rec.image_url.length > 0 || rec.message !== ""
        )
      : [];



    const payload = {
      assessment_id: assessment_id ? assessment_id : AssesmentId,
      category_id: category_id,
      sub_category_id: sub_category_id,
      question_id: question_id,
      notes: data?.observation,
      insights: data?.insights,
      final_score: data?.finalScore,
      users: userData,
      is_reviewed: true,
      ...(uploads?.length > 0 && { upload: uploads}),
      ...(recommendations?.length > 0 && { message: recommendations }),
    };

    if (isLastSubCategory) {
      if (!isLastCategory) {
        setCurrentCategoryIndex(currentCategoryIndex + 1);
        setActiveCategoryId(categories[currentCategoryIndex + 1]?.category_id);
        setCurrentSubCategoryIndex(0);
      }
    } else {
      if (userData.length === 0 || !data?.is_scorable) {
        setCurrentSubCategoryIndex(currentSubCategoryIndex + 1);
      } else {
        dispatch(
          addAssessmentAnswerScore({
            data: payload,
            callBack: handleSubmitResponse,
          })
        );
      }
    }
    scrollToTop()
  };

  const handleSubmitResponse = () => {
    setCurrentSubCategoryIndex(currentSubCategoryIndex + 1);
    const updatedData = [...categories];
    const currentQuestionData =
      updatedData[currentCategoryIndex].sub_categories[currentSubCategoryIndex]
        .questions;
    const completedQuestions = currentQuestionData.filter(
      (question) => question.finalScore
    ).length;

    if (completedQuestions) {
      updatedData[currentCategoryIndex].sub_categories[
        currentSubCategoryIndex
      ].isCompleted = true;
    }
    setValue("categories", updatedData);
  };

  const handleNext = () => {
    // console.log(previousDataTemp,'previous data')
    if (isLastSubCategory) {
      if (!isLastCategory) {
        setCurrentCategoryIndex(currentCategoryIndex + 1);
        setActiveCategoryId(categories[currentCategoryIndex + 1]?.category_id);
        setCurrentSubCategoryIndex(0);
        scrollToTop(".sub-module-wrap")
      }
    } else {
      const data =
        categories[currentCategoryIndex]?.sub_categories[currentSubCategoryIndex]
          ?.questions[currentQuestionIndex];

      const userData = Array.isArray(data?.userAnswer)
        ? data?.userAnswer.map((item) => ({
          user_id: item?.user_id,
          user_name: item?.user_name,
        }))
        : [];

      const uploads = Array.isArray(data?.evidence)
        ? data.evidence.map((ev) => ({
          image_url:
            Array.isArray(ev?.files) && ev.files.length > 0 ? ev.files : [],
          text: ev?.description || "",
        })).filter((evidence) => evidence?.image_url?.length > 0 || evidence?.text !== "")
        : [];



      const recommendations = Array.isArray(data?.recommendation)
        ? data.recommendation.map((rec) => ({
          message: rec?.recText || "",
          image_url:
            Array.isArray(rec?.files) && rec.files.length > 0
              ? rec.files
              : [],
               users: userData,
        }))
          .filter(
            (rec) => rec.image_url.length > 0 || rec.message !== ""
          )
        : [];



      const payload = {
        assessment_id: assessment_id ? assessment_id : AssesmentId,
        category_id: category_id,
        sub_category_id: sub_category_id,
        question_id: question_id,
        notes: data?.observation,
        insights: data?.insights,
        final_score: data?.finalScore,
        is_deleted: false,
        ...(uploads?.length > 0 && {upload: uploads}),
        ...(recommendations?.length > 0 && { messages: recommendations }),
      };

      dispatch(
        updateAssessmentAnswerScore({
          data: payload,
          callBack: () => {
            setCurrentSubCategoryIndex(currentSubCategoryIndex + 1);
            const updatedData = [...categories];
            const currentQuestionData =
              updatedData[currentCategoryIndex].sub_categories[
                currentSubCategoryIndex
              ].questions;
            const completedQuestions = currentQuestionData.filter(
              (question) => question.finalScore
            ).length;

            if (completedQuestions) {
              updatedData[currentCategoryIndex].sub_categories[
                currentSubCategoryIndex
              ].isCompleted = true;
            }
            setValue("categories", updatedData);
          },
        })
      );

      setCurrentSubCategoryIndex(currentSubCategoryIndex + 1);
      scrollToTop();
    }
  };

  return (
    <MainLayout>
      {isloading ? (
        <div className="loader-wrapper" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh' }}>
          <Loader />
        </div>
      ) : (
        <div className="content-section flex flex-col">
          <div className="module-wrap">
            {categories?.map((item, categoryIndex) => (
              <div
                key={categoryIndex}
                className={`moduleLabel ${activeCategoryId === item?.category_id ? "active" : ""
                  }`}
                onClick={() => handleTab(item?.category_id, categoryIndex)}
                style={{ display: "inline-block" }}
              >
                {item?.category_name}
              </div>
            ))}
            <div
              className={`moduleLabel ${issparepartNameImageCategory ? "active" : ""}`}
              onClick={() => {
                setCurrentCategoryIndex(categories.length + 1);
                setActiveCategoryId(sparepartNameImageCategory.category_id);
              }}
              style={{ display: "inline-block" }}
            >
              {sparepartNameImageCategory.category_name}
            </div>
          </div>
          <div className="container-main">
            {issparepartNameImageCategory ? (
              <div style={{ display: "flex", flexDirection: "column", width: "100%", margin: " 0 auto", height: "100%" }}>
                <SparePartUploader
                  isEditable={true}
                  name={productName}
                  setName={setproductName}
                  image={ImageFile}
                  setImage={setImageFile}
                  uploadError={uploadError}
                  setUploadError={setUploadError}
                  isLoading={false}
                />
                <div>
                  {renderNavigationButtons({
                    isTransitioning,
                    currentCategoryIndex,
                    currentSubCategoryIndex,
                    issparepartNameImageCategory,
                    isSparePartsCategory,
                    categories,
                    previousButtonStyle,
                    previousTitle,
                    buttonTitleStyle,
                    buttonStyle,
                    handlePrevious,
                    handleSubmitNameImage,
                    handleSubmitSpare,
                    handleSubmit,
                    handleNext,
                  })}
                </div>
              </div>
            ) : isSparePartsCategory ? renderSpareParts()
              : (
                <>
                  <div className="sub-module-wrap">
                    <h4>Sub-Modules</h4>
                    {filteredSubCategories?.map((item, subCategoryIndex) => {
                      return (
                        <div key={subCategoryIndex}>
                          <SubModule
                            onclick={() => {
                              setCurrentSubCategoryIndex(subCategoryIndex);
                              scrollToTop();
                            }}
                            subModule={item}
                            index={subCategoryIndex}
                            totalSteps={filteredSubCategories?.length}
                            currentSubCategoryIndex={currentSubCategoryIndex}
                            displayNumber={item?.subCategory_id}
                          />
                        </div>
                      );
                    })}
                  </div>
                  <div className="question-wrap">
                    <AssessmentAnswer
                      formMethods={formMethods}
                      categories={categories}
                      categoryIndex={currentCategoryIndex}
                      setCategoryIndex={setCurrentCategoryIndex}
                      subCategoryIndex={currentSubCategoryIndex}
                      setSubCategoryIndex={setCurrentSubCategoryIndex}
                      disabled={disabled}
                      setIsTransitioning={setIsTransitioning}
                    />
                    <div>
                      {renderNavigationButtons({
                        isTransitioning,
                        currentCategoryIndex,
                        currentSubCategoryIndex,
                        issparepartNameImageCategory,
                        isSparePartsCategory,
                        categories,
                        previousButtonStyle,
                        previousTitle,
                        buttonTitleStyle,
                        buttonStyle,
                        handlePrevious,
                        handleSubmitNameImage,
                        handleSubmitSpare,
                        handleSubmit,
                        handleNext,
                      })}
                    </div>
                  </div>
                </>
              )}
          </div>
        </div>
      )}
    </MainLayout>
  );
};

export default ViewReviewAssessment;